import Request from "@/common/net/request.js";
const request = new Request();

// 个人中心修改手机号
export function updatePhone(data) {
  return request.send({
    url: `/system/user/personal/phone`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 个人中心修改密码
export function updatePassword(data) {
  return request.send({
    url: `/system/user/personal/pwd`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 个人中心修改头像
export function updatePhoto(data) {
  return request.send({
    url: `/system/user/head_portrait`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
